import { type FC } from "react";

import { CourseAdminCourseItem } from "./CourseAdminCourseItem";

import { Checkbox } from "mds/components/Checkbox";
import { ListItem } from "mds/components/ListItem";
import { FolderIcon } from "mds/icons";
import {
  courseGroupingSelectors,
  selectAdminAccessibleCourseIdsByGroupingId,
} from "store/selectors";
import { useListSelector, useObjectSelector } from "store/store-hooks";

type CourseAdminGroupingItemProps = {
  groupingId: string;
  isGroupingSelected: boolean;
  selectedCourseIds: Set<string>;
  onGroupingToggle: (groupingId: string) => void;
  onCourseToggle: (courseId: string) => void;
};

export const CourseAdminGroupingItem: FC<CourseAdminGroupingItemProps> = ({
  groupingId,
  isGroupingSelected,
  selectedCourseIds,
  onGroupingToggle,
  onCourseToggle,
}) => {
  const grouping = useObjectSelector(
    (s) => courseGroupingSelectors.selectById(s, groupingId),
    ["title"],
  );
  const courseIds = useListSelector((s) =>
    selectAdminAccessibleCourseIdsByGroupingId(s, groupingId),
  );

  if (!grouping) {
    return null;
  }

  return (
    <div className="mb-2 last:mb-0">
      <ListItem className="w-full gap-2">
        <Checkbox
          checked={isGroupingSelected}
          className="w-full"
          onChange={() => onGroupingToggle(groupingId)}
        >
          <span className="flex w-full items-center gap-2">
            <FolderIcon className="shrink-0 text-black-tint-70" />
            <span>{grouping.title}</span>
          </span>
        </Checkbox>
      </ListItem>

      {courseIds.map((courseId) => (
        <div className="pl-6" key={courseId}>
          <CourseAdminCourseItem
            courseId={courseId}
            isChecked={isGroupingSelected || selectedCourseIds.has(courseId)}
            isDisabled={isGroupingSelected}
            onToggle={onCourseToggle}
          />
        </div>
      ))}
    </div>
  );
};
